import React, { useState } from "react";
import IcCloseEnlarge from "./IcCloseEnlarge.svg";
import IcEnlarge from "./IcEnlarge.svg";
import styles from "./PlaygroundSideActions.module.scss";
import { styled } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import ADSImage from "../../../../../../../../../ADSImage";
import { useADSContext } from "../../../../../../../../../../context/ADSProvider";
import { useAIToolsContext } from "../../../../../../../../../../context/AIToolsProvider";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FB4764",
    boxShadow: theme.shadows[1],
    fontSize: 12,
    fontWeight: 400,
    color: "#FFFFFF",

    ".MuiTooltip-arrow": {
      color: "#FB4764",
    },
  },
}));

const Enlarge = () => {
  const { selectedProduct } = useADSContext();
  const { firstSelectedImage } = useAIToolsContext();

  const [showZoom, setShowZoom] = useState(false);

  return (
    <>
      <LightTooltip title="Enlarge" arrow placement="right">
        <img
          src={IcEnlarge}
          alt="enlarge"
          className={styles.icon}
          onClick={() => setShowZoom(true)}
        />
      </LightTooltip>

      {showZoom && (
        <div
          style={{
            position: "fixed",
            height: "100%",
            width: "100%",
            top: 0,
            left: 0,
            zIndex: 9999,
          }}
          onClick={() => setShowZoom(false)}
        >
          <div
            style={{
              backgroundColor: "#fff1f2",
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          ></div>
          {showZoom && (
            <span
              style={{
                position: "absolute",
                top: 20,
                right: 0,
                height: 40,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <span
                style={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: "#474F59",
                }}
              >
                Close
              </span>

              <img
                src={IcCloseEnlarge}
                alt="Exit Full Screen"
                onClick={() => setShowZoom((prev) => !prev)}
              />
            </span>
          )}

          <ADSImage
            path={selectedProduct.imageUrl}
            file={firstSelectedImage}
            style={{
              transition:
                "transform 0.3s ease-in-out, opacity 0.4s ease-in-out",
              position: "fixed",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 100,
              maxWidth: "90dvw",
              maxHeight: "90vh",
            }}
          />
        </div>
      )}
    </>
  );
};

export default Enlarge;
